import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const DuplicateEntryPrompt = props => {
  return (
    <div>
      <Modal.Header>Duplicate Class</Modal.Header>
      <Modal.Body>
        {props.entry.title} is already in {props.playlist.title}. Are you sure
        you want to still add it?
      </Modal.Body>

      <Modal.Footer>
        <button className='grey' onClick={props.onCancel}>
          Cancel
        </button>
        <button className='btn alo-button' onClick={props.onConfirm}>
          Add
        </button>
      </Modal.Footer>
    </div>
  )
}

DuplicateEntryPrompt.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  entry: PropTypes.object,
  playlist: PropTypes.object
}

export default DuplicateEntryPrompt
